import React from "react";

const data = [
  { Nom: "Aérocycle*", Longueur: 46, Largeur: 14, Hauteur: 28, Poids: 3.7 },
  { Nom: "Albatros", Longueur: 48, Largeur: 78, Hauteur: 28, Poids: 5.5 },
  { Nom: "Anax", Longueur: 48, Largeur: 80, Hauteur: 36, Poids: 2.0 },
  { Nom: "Autographomètre", Longueur: 67, Largeur: 14, Hauteur: 36, Poids: 3.5 },
  { Nom: "Batfly", Longueur: 42, Largeur: 55, Hauteur: 38, Poids: 5.0 },
  { Nom: "Bernin/A", Longueur: 60, Largeur: 23, Hauteur: 41, Poids: 12.6 },
  { Nom: "Bicycle", Longueur: 59, Largeur: 29, Hauteur: 34, Poids: 5.4 },
  { Nom: "Bombyx", Longueur: 57, Largeur: 60, Hauteur: 40, Poids: 5.1 },
  { Nom: "Céphaloscope*", Longueur: 26, Largeur: 24, Hauteur: 32, Poids: 4.5 },
  { Nom: "Chronos 2", Longueur: 45, Largeur: 34, Hauteur: 42, Poids: 5.3 },
  { Nom: "Chronos*", Longueur: 34, Largeur: 44, Hauteur: 28, Poids: 8.1 },
  { Nom: "Faucon", Longueur: 45, Largeur: 23, Hauteur: 29, Poids: 4.4 },
  { Nom: "Frelon*", Longueur: 38, Largeur: 34, Hauteur: 33, Poids: 4.6 },
  { Nom: "Furax", Longueur: 52, Largeur: 29, Hauteur: 31, Poids: 6.4 },
  { Nom: "Gargantua*", Longueur: 73, Largeur: 21, Hauteur: 36, Poids: 6.9 },
  { Nom: "Gerris*", Longueur: 37, Largeur: 13, Hauteur: 28, Poids: 2.5 },
  { Nom: "Gyroptère", Longueur: 46, Largeur: 14, Hauteur: 28, Poids: 3.7 },
  { Nom: "Hercule", Longueur: 75, Largeur: 21, Hauteur: 48, Poids: 9.7 },
  { Nom: "Icarius*", Longueur: 38, Largeur: 21, Hauteur: 62, Poids: 4.7 },
  { Nom: "KLG", Longueur: 50, Largeur: 25, Hauteur: 35, Poids: 3.9 },
  { Nom: "Lucane", Longueur: 44, Largeur: 19, Hauteur: 34, Poids: 6.2 },
  { Nom: "Luciole", Longueur: 37, Largeur: 24, Hauteur: 34, Poids: 4.3 },
  { Nom: "Luxor", Longueur: 40, Largeur: 21, Hauteur: 45, Poids: 2.8 },
  { Nom: "Marchant", Longueur: 54, Largeur: 26, Hauteur: 34, Poids: 6.5 },
  { Nom: "Mystral", Longueur: 46, Largeur: 12, Hauteur: 24, Poids: 4.7 },
  { Nom: "Nautile", Longueur: 64, Largeur: 22, Hauteur: 33, Poids: 4.0 },
  { Nom: "Octodus", Longueur: 35, Largeur: 70, Hauteur: 39, Poids: 3.5 },
  { Nom: "Planet*", Longueur: 45, Largeur: 98, Hauteur: 44, Poids: 6.0 },
  { Nom: "Polaris", Longueur: 36, Largeur: 18, Hauteur: 28, Poids: 3.4 },
  { Nom: "Rocket", Longueur: 62, Largeur: 15, Hauteur: 34, Poids: 7.8 },
  { Nom: "Stellar*", Longueur: 60, Largeur: 25, Hauteur: 52, Poids: 10.0 },
  { Nom: "Suricate*", Longueur: 51, Largeur: 29, Hauteur: 38, Poids: 5.8 },
  { Nom: "Tamanoir*", Longueur: 44, Largeur: 24, Hauteur: 35, Poids: 4.5 },
  { Nom: "Tornado", Longueur: 65, Largeur: 32, Hauteur: 48, Poids: 7.2 },
  { Nom: "Torpeur*", Longueur: 76, Largeur: 20, Hauteur: 26, Poids: 7.0 },
  { Nom: "Truffier", Longueur: 65, Largeur: 26, Hauteur: 37, Poids: 5.6 },
  { Nom: "Underwood", Longueur: 45, Largeur: 62, Hauteur: 32, Poids: 6.0 },
  { Nom: "Vigilant", Longueur: 33, Largeur: 20, Hauteur: 32, Poids: 2.4 },
  { Nom: "Vulcan-X3", Longueur: 45, Largeur: 15, Hauteur: 56, Poids: 4.2 },
];

// Tri automatique (sécurité)
const sortedData = [...data].sort((a, b) =>
  a.Nom.localeCompare(b.Nom, "fr", { sensitivity: "base" })
);

export default function Maquettes() {
  return (
    <div className="min-h-screen bg-[#fdf6e3] p-8 font-serif text-gray-800">
      {/* Cartouche décoratif */}
      <div className="border-8 border-double border-[#7b3f00] rounded-2xl p-6 mb-8 bg-gradient-to-b from-[#fff5e1] to-[#f2e4c6] shadow-xl">
        <h1 className="text-4xl font-bold text-center text-[#7b3f00] drop-shadow-lg tracking-wide">
          📜 Registre des Maquettes
        </h1>
        <p className="text-center italic text-[#5b3a29] mt-2">
          Inventaire des maquettes réalisées à ce jour par Dominique Formaz.
        </p>
      </div>

      {/* Tableau */}
      <div className="overflow-x-auto">
        <table className="mx-auto border-4 border-[#7b3f00] rounded-lg shadow-lg bg-[#fffbea]">
          <thead className="bg-[#e6d3a3] text-[#3a1d0b] uppercase tracking-widest">
            <tr>
              <th className="px-6 py-3 border border-[#7b3f00]">Nom</th>
              <th className="px-6 py-3 border border-[#7b3f00]">Longueur</th>
              <th className="px-6 py-3 border border-[#7b3f00]">Largeur</th>
              <th className="px-6 py-3 border border-[#7b3f00]">Hauteur</th>
              <th className="px-6 py-3 border border-[#7b3f00]">Poids</th>
            </tr>
          </thead>
          <tbody>
            {sortedData.map((item, index) => (
              <tr
                key={index}
                className={`hover:bg-[#f0e4c3] transition ${
                  index % 2 === 0 ? "bg-[#fffbea]" : "bg-[#faf3dd]"
                }`}
              >
                <td className="px-6 py-2 border border-[#7b3f00] font-semibold">
                  {item.Nom}
                </td>
                <td className="px-6 py-2 border border-[#7b3f00]">{item.Longueur}</td>
                <td className="px-6 py-2 border border-[#7b3f00]">{item.Largeur}</td>
                <td className="px-6 py-2 border border-[#7b3f00]">{item.Hauteur}</td>
                <td className="px-6 py-2 border border-[#7b3f00]">{item.Poids}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="mt-6 text-center italic text-[#5b3a29]">
        * Vendue
      </p>
    </div>
  );
}